<script setup lang="ts"></script>

<template>
  <NuxtLink to="/">
    <div class="flex items-center">
      <img
      src="/assets/shobzoy_logo_logo.png"
      alt="Logo"
      class="h-10 object-cover"
    />

    <p class="text-xl font-semibold  bg-gradient-to-r from-blue-600 via-green-500 to-indigo-400 inline-block text-transparent bg-clip-text">Shopzoy</p>
    </div>
    
  </NuxtLink>
</template>
